import { ADMIN_ABILITY, ADMIN_CSM_ABILITY, ADMIN_SDR_ABILITY, CSM_ABILITY, SDR_ABILITY, SUPERADMIN_ABILITY } from "../ability/common";
import { ADMIN_CSM_ROLE, ADMIN_SDR_ROLE, CSM_ROLE, SDR_ROLE, SUPERADMIN_ROLE } from "../constants/panel/common";

import { AbilityContext } from "@context/can";
import { UserContext } from "../context/user";
import i18next from "i18next";
import { setItemToStore } from "@helpers/utils";
import size from "lodash/size";
import { useContext } from "react";

const usePanelAbility = () => {
    const ability = useContext(AbilityContext);
    const { userData = {} } = useContext(UserContext);
    /**
   * It takes a response object and updates the ability object based on the type of organization
   * @param response - The response from the server.
   */
    const handlePanelAbility = ({
        userInfo = {}
    }) => {
        const {
            user = {}
        } = size(userInfo) ? userInfo : userData;

        const isSuperadmin = user.role === SUPERADMIN_ROLE;
        const tempUser = size(userInfo) ? userInfo : userData;
        let modifiedAbility = [];

        if (size(user)) {
            if (user.role === ADMIN_CSM_ROLE) {
                modifiedAbility = modifiedAbility.concat(ADMIN_CSM_ABILITY);
            } else if (user.role === ADMIN_SDR_ROLE) {
                modifiedAbility = modifiedAbility.concat(ADMIN_SDR_ABILITY);
            } else if (user.role === CSM_ROLE) {
                modifiedAbility = modifiedAbility.concat(CSM_ABILITY);
            } else if (user.role === SDR_ROLE) {
                modifiedAbility = modifiedAbility.concat(SDR_ABILITY);
            } else if (isSuperadmin) {
                modifiedAbility = modifiedAbility.concat(SUPERADMIN_ABILITY);
            } else {
                modifiedAbility = modifiedAbility.concat(ADMIN_ABILITY);
            }
            
            if (isSuperadmin) {
                setItemToStore("superadminInfo", tempUser);
            } else {
                setItemToStore("userInfo", tempUser);
            }
            setItemToStore("lang", user.lang || "en");
        }

        i18next.changeLanguage(user.lang);
        setItemToStore("isLogoutRequired", false);

        ability.update(modifiedAbility);
        setItemToStore("ability", modifiedAbility);
        window.dispatchEvent(new Event("ability"));
    };

    return {
        handlePanelAbility
    };
};
export default usePanelAbility;
